export default defineNuxtRouteMiddleware(to => {
    // Match /hotel/{city}/{something}-star
    const match = RegExp(/^\/hotel\/([^/]+)\/[^/]*-star$/).exec(to.path);

    if (match) {
        const [, city] = match;
        console.log('[middleware] Redirecting to /hotel/', city, '');

        return navigateTo(`/hotel/${city}`);
    }
});
